module.exports = __webpack_public_path__ + "static/standard3-349687befcb587057542b373ec306bcb.png";